import classNames from "classnames";
import { Icon } from "../Icon/Icon.tsx";

export const Checkbox = ({
  label,
  checked,
  disabled,
  onChange,
}: {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <div className="flex-row gap-200 items-center">
    <button
      disabled={disabled}
      type="button"
      className={classNames(
        "flex-row-center items-center",
        "h-400 w-400 rounded-100",
        !checked &&
          !disabled &&
          "border-input-border-width border-input-border-rest bg-input-surface-rest hover:bg-input-surface-hover",
        disabled
          ? "bg-input-surface-disabled"
          : checked
          ? "bg-surface-inverse-rest"
          : "bg-input-surface-rest hover:bg-input-surface-hover",
      )}
      onClick={() => onChange(!checked)}
    >
      {checked && <Icon name="Check" size="sm" className="text-white" />}
    </button>
    <div
      className={classNames(
        "label-md-default",
        disabled ? "text-primary-disabled" : "text-primary",
      )}
    >
      {label}
    </div>
  </div>
);
